import { DragGesture as r } from "./atoms-v21074.js";
import { PanGesture as o } from "./atoms-v21075.js";
import { MeasureLayout as e } from "./atoms-v21076.js";
import { HTMLProjectionNode as t } from "./atoms-v21077.js";
const u = {
  pan: {
    Feature: o
  },
  drag: {
    Feature: r,
    ProjectionNode: t,
    MeasureLayout: e
  }
};
export {
  u as drag
};
